<template>
  <div class="all_part">
    <div class="logo">
      <img src="../assets/main_menu_Phone/Logo.png" alt=""/>
    </div>
    <div class="button_input_all">
      <div class="input_button">

        <div class="all_input">
          <div class="all_input_top">
            <el-input
                v-model="key"
                placeholder="请输入搜索条件"
                style="width: 190px"
            ></el-input>
          </div>
          <div class="submit_button">
            <div class="search_buttons">
              <div class="sousuoButton">
                <el-button
                    type="primary"
                    @click="serchChanPin4"
                    style="
                  height: 34pt;
                  width: 70pt;
                  background-image: linear-gradient(to right, #358fe5, #1d6eb9);
                "
                >搜索
                </el-button>
                <div class="sousuo_icon">
                  <img src="../assets/SouSuo.png" alt="" width="14pt"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tables_input_mainMenu_button">
        <div class="main_buttonAndInput">
          <div class="main_button">
            <div class=" button_table_all">
              <div :class="pan_Show? 'CompetitiveChoice' : 'CompetitiveChoices'">
                <div class="Main_menu_button_cl">
                  <div :class="pan_input==1?'CompetitiveChoice_button_ch':'CompetitiveChoice_button'"
                       @click="JingPinDengJi(item.id)"
                       v-for="item in tableTable" v-if="item.id==1">
                    <div class="CompetitiveChoice_button_alone" style="background:#409EFF ">
                      <span class="alone_span_title">{{ item.quadrant }}</span>
                    </div>
                  </div>
                  <div :class="pan_input==3?'CompetitiveChoice_button_ch':'CompetitiveChoice_button'"
                       @click="JingPinDengJi(item.id)"
                       v-for="item in tableTable" v-if="item.id==3">
                    <div class="CompetitiveChoice_button_alone" style="background:#409EFF ">
                      <span class="alone_span_title">{{ item.quadrant }}</span>
                    </div>
                  </div>
                  <div :class="pan_input==5?'CompetitiveChoice_button_ch':'CompetitiveChoice_button'"
                       @click="JingPinDengJi(item.id)"
                       v-for="item in tableTable" v-if="item.id==5">
                    <div class="CompetitiveChoice_button_alone" style="background:#409EFF ">
                      <span class="alone_span_title">{{ item.quadrant }}</span>
                    </div>
                  </div>
                </div>
                <div class="Main_menu_button_cl">
                  <div
                      :class="FABstaff_name_select==''&&staff_name_select==''||pan_input!=1?'CompetitiveChoice_buttonss':'CompetitiveChoice_buttonss1'"
                      @click="JingPinDengJi2(item.id)"
                      v-for="item in tableTable" v-if="item.id==2">
                    <div class="CompetitiveChoice_button_alone">
                      <span class="alone_span_title">{{ item.quadrant }}</span>
                    </div>
                  </div>
                  <div
                      :class="OEMstaff_name_select==''&&FABstaff_name_select==''||pan_input!=3?'CompetitiveChoice_buttonss':'CompetitiveChoice_buttonss2'"
                      @click="JingPinDengJi2(item.id)"
                      v-for="item in tableTable" v-if="item.id==4">
                    <div class="CompetitiveChoice_button_alone">
                      <span class="alone_span_title">{{ item.quadrant }}</span>
                    </div>
                  </div>
                  <div
                      :class="staff_name_select==''&&OEMstaff_name_select==''||pan_input!=5?'CompetitiveChoice_buttonss':'CompetitiveChoice_buttonss3'"
                      @click="JingPinDengJi2(item.id)"
                      v-for="item in tableTable" v-if="item.id==6">
                    <div class="CompetitiveChoice_button_alone">
                      <span class="alone_span_title">{{ item.quadrant }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="change_tab" v-show="pan_input4">
            <div :class="pan_input3==false?'bottom_ch' : ''" @click="pan_switch(0)">
              <span>登记信息</span>
            </div>
            <div :class="pan_input3==true ?'bottom_ch' : ''" @click="pan_switch(1)">
              <span>数据详情</span>
            </div>
          </div>
          <div class="title_switch_table" v-show="pan_input3==true&&pan_input2==1||pan_input2==3||pan_input2==5">
            <div :class="pan_input5==false?'bottom_ch' : ''" @click="pan_switch2(1)">
              <span>{{ title_switch1(pan_input2) }}</span>
            </div>
            <div :class="pan_input5==true?'bottom_ch' : ''" @click="pan_switch2(0)">
              <span>{{ title_switch1(pan_input) }}</span>
            </div>
          </div>
          <div>
            <div :class="PanDuanShous ? 'all_spans2':'all_spans'" v-if="pan_input3==true&&pan_input==1">
              <div class="all_key">
                <div v-for="(item, i) in tableData" class="list_div">
                  <div class="list_div_button">
                    <el-button
                        @click="TianJiaTest(item.id)"
                        style="width: 80px"
                    >
                      详情
                    </el-button>
                  </div>
                  <div class="Key">
                    <span class="There_span">所属象限</span>
                    <span>{{ item.quadrant }}</span>
                  </div>
                  <div class="Key">
                    <span class="There_span">竞争对手</span>
                    <span>{{ item.enterprise }}</span>
                  </div>
                  <div class="Key">
                    <span>竞争人员</span>
                    <span>{{ item.enterprise_name }}</span>
                  </div>
                  <div class="Key">
                    <span>竞争对手关联类型</span>
                    <span>{{ item.enterprise_type }}</span>
                  </div>
                  <div class="Key">
                    <span>人员关系&活动</span>
                    <span>{{ item.personnel_relations }}</span>
                  </div>

                  <div class="Key">
                    <span>添加时间</span>
                    <span>{{ item.add_time }}</span>
                  </div>
                  <div class="Key">
                    <span>修改时间</span>
                    <span>{{ item.edit_time }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div :class="PanDuanShous ? 'all_spans2':'all_spans'"
                 v-if="pan_input3==true&&pan_input2==1&&pan_input5==false">
              <div class="all_key">
                <div v-for="(item, i) in tableData" class="list_div">
                  <div class="list_div_button">
                    <el-button
                        @click="TianJiaTest(item.id)"
                        style="width: 80px"
                    >
                      详情
                    </el-button>
                  </div>
                  <div class="Key">
                    <span class="There_span">所属象限</span>
                    <span>{{ item.quadrant }}</span>
                  </div>
                  <div class="Key">
                    <span class="There_span">竞争对手</span>
                    <span>{{ item.enterprise }}</span>
                  </div>
                  <div class="Key">
                    <span>竞争人员</span>
                    <span>{{ item.enterprise_name }}</span>
                  </div>
                  <div class="Key">
                    <span>竞争对手关联类型</span>
                    <span>{{ item.enterprise_type }}</span>
                  </div>
                  <div class="Key">
                    <span>人员关系&活动</span>
                    <span>{{ item.personnel_relations }}</span>
                  </div>

                  <div class="Key">
                    <span>添加时间</span>
                    <span>{{ item.add_time }}</span>
                  </div>
                  <div class="Key">
                    <span>修改时间</span>
                    <span>{{ item.edit_time }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div :class="PanDuanShous ? 'all_spans2':'all_spans'"
                 v-if="pan_input3==true&&pan_input==2&&pan_input5==true">
              <div class="all_key">
                <div v-for="(item, i) in tableData2" class="list_div">
                  <div class="list_div_button">
                    <el-button
                        @click="TianJiaTest(item.id)"
                        style="width: 80px"
                    >
                      详情
                    </el-button>
                  </div>
                  <div class="Key">
                    <span class="There_span">所属象限</span>
                    <span>{{ item.quadrant }}</span>
                  </div>
                  <div class="Key">
                    <span class="There_span">竞争对手</span>
                    <span>{{ item.enterprise }}</span>
                  </div>
                  <div class="Key">
                    <span>竞争人员</span>
                    <span>{{ item.enterprise_name }}</span>
                  </div>
                  <div class="Key">
                    <span>竞争对手关联类型</span>
                    <span>{{ item.enterprise_type }}</span>
                  </div>
                  <div class="Key">
                    <span>人员关系&活动</span>
                    <span>{{ item.personnel_relations }}</span>
                  </div>

                  <div class="Key">
                    <span>添加时间</span>
                    <span>{{ item.add_time }}</span>
                  </div>
                  <div class="Key">
                    <span>修改时间</span>
                    <span>{{ item.edit_time }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div :class="PanDuanShous ? 'all_spans2':'all_spans'" v-if="pan_input3==true&&pan_input==3">
              <div class="all_key">
                <div v-for="(item, i) in tableData" class="list_div">
                  <div class="list_div_button">
                    <el-button
                        @click="TianJiaTest(item.id)"
                        style="width: 80px"
                    >
                      详情
                    </el-button>
                  </div>
                  <div class="Key">
                    <span class="There_span">所属象限</span>
                    <span>{{ item.quadrant }}</span>
                  </div>
                  <div class="Key">
                    <span class="There_span">最终用户</span>
                    <span>{{ item.enterprise_end }}</span>
                  </div>
                  <div class="Key">
                    <span>最终用户竞争人员</span>
                    <span>{{ item.enterprise_end_name }}</span>
                  </div>
                  <div class="Key">
                    <span>最终用户关联类型</span>
                    <span>{{ item.enterprise_end_type }}</span>
                  </div>
                  <div class="Key">
                    <span>设备型号</span>
                    <span>{{ item.device_type }}</span>
                  </div>
                  <div class="Key">
                    <span>制程工艺</span>
                    <span>{{ item.process_technology }}</span>
                  </div>
                  <div class="Key">
                    <span>竞品类别</span>
                    <span>{{ item.category }}</span>
                  </div>
                  <div class="Key">
                    <span>添加时间</span>
                    <span>{{ item.add_time }}</span>
                  </div>
                  <div class="Key">
                    <span>修改时间</span>
                    <span>{{ item.edit_time }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div :class="PanDuanShous ? 'all_spans2':'all_spans'"
                 v-if="pan_input3==true&&pan_input2==3&&pan_input5==true">

              <div class="all_key">
                <div v-for="(item, i) in tableData" class="list_div">
                  <div class="list_div_button">
                    <el-button
                        @click="TianJiaTest(item.id)"
                        style="width: 80px"
                    >
                      详情
                    </el-button>
                  </div>
                  <div class="Key">
                    <span class="There_span">所属象限</span>
                    <span>{{ item.quadrant }}</span>
                  </div>
                  <div class="Key">
                    <span class="There_span">最终用户</span>
                    <span>{{ item.enterprise_end }}</span>
                  </div>
                  <div class="Key">
                    <span>最终用户竞争人员</span>
                    <span>{{ item.enterprise_end_name }}</span>
                  </div>
                  <div class="Key">
                    <span>最终用户关联类型</span>
                    <span>{{ item.enterprise_end_type }}</span>
                  </div>
                  <div class="Key">
                    <span>设备型号</span>
                    <span>{{ item.device_type }}</span>
                  </div>
                  <div class="Key">
                    <span>制程工艺</span>
                    <span>{{ item.process_technology }}</span>
                  </div>
                  <div class="Key">
                    <span>竞品类别</span>
                    <span>{{ item.category }}</span>
                  </div>
                  <div class="Key">
                    <span>添加时间</span>
                    <span>{{ item.add_time }}</span>
                  </div>
                  <div class="Key">
                    <span>修改时间</span>
                    <span>{{ item.edit_time }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div :class="PanDuanShous ? 'all_spans2':'all_spans'"
                 v-if="pan_input3==true&&pan_input==4&&pan_input5==false">
              <div class="all_key">
                <div v-for="(item, i) in tableData2" class="list_div">
                  <div class="list_div_button">
                    <el-button
                        @click="TianJiaTest(item.id)"
                        style="width: 80px"
                    >
                      详情
                    </el-button>
                  </div>
                  <div class="Key">
                    <span class="There_span">所属象限</span>
                    <span>{{ item.quadrant }}</span>
                  </div>
                  <div class="Key">
                    <span class="There_span">最终用户</span>
                    <span>{{ item.enterprise_end }}</span>
                  </div>
                  <div class="Key">
                    <span>最终用户竞争人员</span>
                    <span>{{ item.enterprise_end_name }}</span>
                  </div>
                  <div class="Key">
                    <span>最终用户关联类型</span>
                    <span>{{ item.enterprise_end_type }}</span>
                  </div>
                  <div class="Key">
                    <span>设备型号</span>
                    <span>{{ item.device_type }}</span>
                  </div>
                  <div class="Key">
                    <span>制程工艺</span>
                    <span>{{ item.process_technology }}</span>
                  </div>
                  <div class="Key">
                    <span>竞品类别</span>
                    <span>{{ item.category }}</span>
                  </div>
                  <div class="Key">
                    <span>添加时间</span>
                    <span>{{ item.add_time }}</span>
                  </div>
                  <div class="Key">
                    <span>修改时间</span>
                    <span>{{ item.edit_time }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div :class="PanDuanShous ? 'all_spans2':'all_spans'" v-if="pan_input3==true&&pan_input==5">
              <div class="all_key">
                <div v-for="(item, i) in tableData" class="list_div">
                  <div class="list_div_button">
                    <el-button
                        @click="TianJiaTest(item.id)"
                        style="width: 80px"
                    >
                      详情
                    </el-button>
                  </div>
                  <div class="Key">
                    <span class="There_span">所属象限</span>
                    <span>{{ item.quadrant }}</span>
                  </div>
                  <div class="Key">
                    <span class="There_span">OEM设备商</span>
                    <span>{{ item.equipment_supplier }}</span>
                  </div>
                  <div class="Key">
                    <span>设备竞争人员</span>
                    <span>{{ item.related_personnel_supplier_name }}</span>
                  </div>
                  <div class="Key">
                    <span>设备关联类型</span>
                    <span>{{ item.equipment_supplier_type }}</span>
                  </div>
                  <div class="Key">
                    <span>设备型号</span>
                    <span>{{ item.device_type }}</span>
                  </div>

                  <div class="Key">
                    <span>人员关系&活动</span>
                    <span>{{ item.personnel_relations }}</span>
                  </div>
                  <div class="Key">
                    <span>制程工艺</span>
                    <span>{{ item.process_technology }}</span>
                  </div>
                  <div class="Key">
                    <span>添加时间</span>
                    <span>{{ item.add_time }}</span>
                  </div>
                  <div class="Key">
                    <span>修改时间</span>
                    <span>{{ item.edit_time }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div :class="PanDuanShous ? 'all_spans2':'all_spans'"
                 v-if="pan_input3==true&&pan_input2==5&&pan_input5==false">
              <div class="all_key">
                <div v-for="(item, i) in tableData" class="list_div">
                  <div class="list_div_button">
                    <el-button
                        @click="TianJiaTest(item.id)"
                        style="width: 80px"
                    >
                      详情
                    </el-button>
                  </div>
                  <div class="Key">
                    <span class="There_span">所属象限</span>
                    <span>{{ item.quadrant }}</span>
                  </div>
                  <div class="Key">
                    <span class="There_span">OEM设备商</span>
                    <span>{{ item.equipment_supplier }}</span>
                  </div>
                  <div class="Key">
                    <span>设备竞争人员</span>
                    <span>{{ item.related_personnel_supplier_name }}</span>
                  </div>
                  <div class="Key">
                    <span>设备关联类型</span>
                    <span>{{ item.equipment_supplier_type }}</span>
                  </div>
                  <div class="Key">
                    <span>设备型号</span>
                    <span>{{ item.device_type }}</span>
                  </div>

                  <div class="Key">
                    <span>人员关系&活动</span>
                    <span>{{ item.personnel_relations }}</span>
                  </div>
                  <div class="Key">
                    <span>制程工艺</span>
                    <span>{{ item.process_technology }}</span>
                  </div>
                  <div class="Key">
                    <span>添加时间</span>
                    <span>{{ item.add_time }}</span>
                  </div>
                  <div class="Key">
                    <span>修改时间</span>
                    <span>{{ item.edit_time }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div :class="PanDuanShous ? 'all_spans2':'all_spans'"
                 v-if="pan_input3==true&&pan_input==6&&pan_input5==true">
              <div class="all_key">
                <div v-for="(item, i) in tableData2" class="list_div">
                  <div class="list_div_button">
                    <el-button
                        @click="TianJiaTest(item.id)"
                        style="width: 80px"
                    >
                      详情
                    </el-button>
                  </div>
                  <div class="Key">
                    <span class="There_span">所属象限</span>
                    <span>{{ item.quadrant }}</span>
                  </div>
                  <div class="Key">
                    <span class="There_span">OEM设备商</span>
                    <span>{{ item.equipment_supplier }}</span>
                  </div>
                  <div class="Key">
                    <span>设备竞争人员</span>
                    <span>{{ item.related_personnel_supplier_name }}</span>
                  </div>
                  <div class="Key">
                    <span>设备关联类型</span>
                    <span>{{ item.equipment_supplier_type }}</span>
                  </div>
                  <div class="Key">
                    <span>设备型号</span>
                    <span>{{ item.device_type }}</span>
                  </div>

                  <div class="Key">
                    <span>人员关系&活动</span>
                    <span>{{ item.personnel_relations }}</span>
                  </div>
                  <div class="Key">
                    <span>制程工艺</span>
                    <span>{{ item.process_technology }}</span>
                  </div>
                  <div class="Key">
                    <span>添加时间</span>
                    <span>{{ item.add_time }}</span>
                  </div>
                  <div class="Key">
                    <span>修改时间</span>
                    <span>{{ item.edit_time }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="pan_input5==true&&pan_input6==1">
            <div :class="PanDuanShous ? 'all_spans2':'all_spans'" v-if="pan_input3==true&&pan_input==2">
              <div class="all_key">
                <div v-for="(item, i) in tableData2" class="list_div">
                  <div class="list_div_button">
                    <el-button
                        @click="TianJiaTest(item.id)"
                        style="width: 80px"
                    >
                      详情
                    </el-button>
                  </div>
                  <div class="Key">
                    <span class="There_span">所属象限</span>
                    <span>{{ item.quadrant }}</span>
                  </div>
                  <div class="Key">
                    <span class="There_span">竞争对手</span>
                    <span>{{ item.enterprise }}</span>
                  </div>
                  <div class="Key">
                    <span>竞争人员</span>
                    <span>{{ item.enterprise_name }}</span>
                  </div>
                  <div class="Key">
                    <span>竞争对手关联类型</span>
                    <span>{{ item.enterprise_type }}</span>
                  </div>
                  <div class="Key">
                    <span>人员关系&活动</span>
                    <span>{{ item.personnel_relations }}</span>
                  </div>

                  <div class="Key">
                    <span>添加时间</span>
                    <span>{{ item.add_time }}</span>
                  </div>
                  <div class="Key">
                    <span>修改时间</span>
                    <span>{{ item.edit_time }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div :class="PanDuanShous ? 'all_spans2':'all_spans'" v-if="pan_input3==true&&pan_input==4">
              <div class="all_key">
                <div v-for="(item, i) in tableData2" class="list_div">
                  <div class="list_div_button">
                    <el-button
                        @click="TianJiaTest(item.id)"
                        style="width: 80px"
                    >
                      详情
                    </el-button>
                  </div>
                  <div class="Key">
                    <span class="There_span">所属象限</span>
                    <span>{{ item.quadrant }}</span>
                  </div>
                  <div class="Key">
                    <span class="There_span">最终用户</span>
                    <span>{{ item.enterprise_end }}</span>
                  </div>
                  <div class="Key">
                    <span>最终用户竞争人员</span>
                    <span>{{ item.enterprise_end_name }}</span>
                  </div>
                  <div class="Key">
                    <span>最终用户关联类型</span>
                    <span>{{ item.enterprise_end_type }}</span>
                  </div>
                  <div class="Key">
                    <span>设备型号</span>
                    <span>{{ item.device_type }}</span>
                  </div>
                  <div class="Key">
                    <span>制程工艺</span>
                    <span>{{ item.process_technology }}</span>
                  </div>
                  <div class="Key">
                    <span>竞品类别</span>
                    <span>{{ item.category }}</span>
                  </div>
                  <div class="Key">
                    <span>添加时间</span>
                    <span>{{ item.add_time }}</span>
                  </div>
                  <div class="Key">
                    <span>修改时间</span>
                    <span>{{ item.edit_time }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div :class="PanDuanShous ? 'all_spans2':'all_spans'" v-if="pan_input3==true&&pan_input==6">
              <div class="all_key">
                <div v-for="(item, i) in tableData2" class="list_div">
                  <div class="list_div_button">
                    <el-button
                        @click="TianJiaTest(item.id)"
                        style="width: 80px"
                    >
                      详情
                    </el-button>
                  </div>
                  <div class="Key">
                    <span class="There_span">所属象限</span>
                    <span>{{ item.quadrant }}</span>
                  </div>
                  <div class="Key">
                    <span class="There_span">OEM设备商</span>
                    <span>{{ item.equipment_supplier }}</span>
                  </div>
                  <div class="Key">
                    <span>设备竞争人员</span>
                    <span>{{ item.related_personnel_supplier_name }}</span>
                  </div>
                  <div class="Key">
                    <span>设备关联类型</span>
                    <span>{{ item.equipment_supplier_type }}</span>
                  </div>
                  <div class="Key">
                    <span>设备型号</span>
                    <span>{{ item.device_type }}</span>
                  </div>

                  <div class="Key">
                    <span>人员关系&活动</span>
                    <span>{{ item.personnel_relations }}</span>
                  </div>
                  <div class="Key">
                    <span>制程工艺</span>
                    <span>{{ item.process_technology }}</span>
                  </div>
                  <div class="Key">
                    <span>添加时间</span>
                    <span>{{ item.add_time }}</span>
                  </div>
                  <div class="Key">
                    <span>修改时间</span>
                    <span>{{ item.edit_time }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>

      <div class="all_input_tan_input" v-if="pan_Show==true">
        <div class="all_input_control">
          <div class="all_control" v-if="pan_input==1">
            <div class="all_control_input_button">
              <div class="Type_title">
                <span>FAB用户</span>
              </div>

              <div>
                <div class="title_input_button">
                  <div class="titles">
                    <span>关联企业</span>
                  </div>
                  <div class="all_input">
                    <el-select v-model="FABcompanChoice" filterable placeholder="请选择" style="width: 200px"
                               value-key="id"
                               clearable @change="change('b', FABcompanChoice)">
                      <el-option
                          v-for="item in FABcompanyTable"
                          :key="item.id"
                          :label="item.enterprise"
                          :value="{id:item.id, companyName:item.enterprise}"
                      >
                      </el-option>
                    </el-select>

                  </div>
                  <div>
                    <el-button @click="add_companyTable=2">新增</el-button>
                  </div>
                </div>

              </div>
              <div>
                <div class="title_input_button">
                  <div class="titles">
                    <span>关联人员</span>
                  </div>
                  <div class="all_input">
                    <el-select v-model="FABstaff_name_select" filterable placeholder="请选择" style="width: 200px">
                      <el-option
                          v-for="item in FABcompanyStaffTable"
                          :key="item.value"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                  <div>
                    <el-button @click="Pan_add_FABstaff">新增</el-button>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="all_control" v-if="pan_input==1">
            <div class="all_control_input_button">
              <div class="Type_title">
                <span>竞品关联信息</span>
              </div>

              <div>
                <div class="title_input_button">
                  <div class="titles">
                    <span>关联企业</span>
                  </div>
                  <div class="all_input">
                    <el-select v-model="companyChoice" filterable placeholder="请选择" style="width: 200px" value-key="id"
                               clearable @change="change('a', companyChoice)">
                      <el-option
                          v-for="item in companyTable"
                          :key="item.id"
                          :label="item.enterprise"
                          :value="{id:item.id, companyName:item.enterprise}"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div>
                    <el-button @click="Pan_add_companyTable">新增</el-button>
                  </div>
                </div>

              </div>
              <div>
                <div class="title_input_button">
                  <div class="titles">
                    <span>关联人员</span>
                  </div>
                  <div class="all_input">
                    <el-select v-model="staff_name_select" filterable placeholder="请选择" style="width: 200px"
                    >
                      <el-option
                          v-for="item in companyStaffTable"
                          :key="item.value"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                  <div>
                    <el-button @click="Pan_add_staff()">新增</el-button>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="all_control" v-if="  pan_input==3">

            <div class="all_control_input_button">
              <div class="Type_title">
                <span>OEM设备商</span>
              </div>

              <div>
                <div class="title_input_button">
                  <div class="titles">
                    <span>关联企业</span>
                  </div>
                  <div class="all_input">
                    <el-select v-model="OEMcompanyChoice" filterable placeholder="请选择" style="width: 200px"
                               value-key="id"
                               clearable @change="change('c', OEMcompanyChoice)">
                      <el-option
                          v-for="item in OEMcompanyTable"
                          :key="item.id"
                          :label="item.enterprise"
                          :value="{id:item.id, companyName:item.enterprise}"
                      >
                      </el-option>
                    </el-select>

                  </div>
                  <div>
                    <el-button @click="add_companyTable=3">新增</el-button>
                  </div>
                </div>

              </div>
              <div>
                <div class="title_input_button">
                  <div class="titles">
                    <span>关联人员</span>
                  </div>
                  <div class="all_input">
                    <el-select v-model="OEMstaff_name_select" filterable placeholder="请选择" style="width: 200px">
                      <el-option
                          v-for="item in OEMcompanyStaffTable"
                          :key="item.value"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                  <div>
                    <el-button @click="Pan_add_OEMstaff">新增</el-button>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="all_control" v-if=" pan_input==3">
            <div class="all_control_input_button">
              <div class="Type_title">
                <span>FAB用户</span>
              </div>

              <div>
                <div class="title_input_button">
                  <div class="titles">
                    <span>关联企业</span>
                  </div>
                  <div class="all_input">
                    <el-select v-model="FABcompanChoice" filterable placeholder="请选择" style="width: 200px"
                               value-key="id"
                               clearable @change="change('b', FABcompanChoice)">
                      <el-option
                          v-for="item in FABcompanyTable"
                          :key="item.id"
                          :label="item.enterprise"
                          :value="{id:item.id, companyName:item.enterprise}"
                      >
                      </el-option>
                    </el-select>

                  </div>
                  <div>
                    <el-button @click="add_companyTable=2">新增</el-button>
                  </div>
                </div>

              </div>
              <div>
                <div class="title_input_button">
                  <div class="titles">
                    <span>关联人员</span>
                  </div>
                  <div class="all_input">
                    <el-select v-model="FABstaff_name_select" filterable placeholder="请选择" style="width: 200px">
                      <el-option
                          v-for="item in FABcompanyStaffTable"
                          :key="item.value"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                  <div>
                    <el-button @click="Pan_add_FABstaff">新增</el-button>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="all_control" v-if="pan_input==5">
            <div class="all_control_input_button">
              <div class="Type_title">
                <span>竞品关联信息</span>
              </div>
              <div>
                <div class="title_input_button">
                  <div class="titles">
                    <span>关联企业</span>
                  </div>
                  <div class="all_input">
                    <el-select v-model="companyChoice" filterable placeholder="请选择" style="width: 200px" value-key="id"
                               clearable @change="change('a', companyChoice)">
                      <el-option
                          v-for="item in companyTable"
                          :key="item.id"
                          :label="item.enterprise"
                          :value="{id:item.id, companyName:item.enterprise}"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div>
                    <el-button @click="Pan_add_companyTable">新增</el-button>
                  </div>
                </div>

              </div>
              <div>
                <div class="title_input_button">
                  <div class="titles">
                    <span>关联人员</span>
                  </div>
                  <div class="all_input">
                    <el-select v-model="staff_name_select" filterable placeholder="请选择" style="width: 200px"
                    >
                      <el-option
                          v-for="item in companyStaffTable"
                          :key="item.value"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                  <div>
                    <el-button @click="Pan_add_staff()">新增</el-button>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="all_control" v-if="  pan_input==5">

            <div class="all_control_input_button">
              <div class="Type_title">
                <span>OEM设备商</span>
              </div>

              <div>
                <div class="title_input_button">
                  <div class="titles">
                    <span>关联企业</span>
                  </div>
                  <div class="all_input">
                    <el-select v-model="OEMcompanyChoice" filterable placeholder="请选择" style="width: 200px"
                               value-key="id"
                               clearable @change="change('c', OEMcompanyChoice)">
                      <el-option
                          v-for="item in OEMcompanyTable"
                          :key="item.id"
                          :label="item.enterprise"
                          :value="{id:item.id, companyName:item.enterprise}"
                      >
                      </el-option>
                    </el-select>

                  </div>
                  <div>
                    <el-button @click="add_companyTable=3">新增</el-button>
                  </div>
                </div>

              </div>
              <div>
                <div class="title_input_button">
                  <div class="titles">
                    <span>关联人员</span>
                  </div>
                  <div class="all_input">
                    <el-select v-model="OEMstaff_name_select" filterable placeholder="请选择" style="width: 200px">
                      <el-option
                          v-for="item in OEMcompanyStaffTable"
                          :key="item.value"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                  <div>
                    <el-button @click="Pan_add_OEMstaff">新增</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="all_input_controls" v-show="pan_input!=''">
          <div class="all_controls">
            <div class="all_control_input_buttons">
              <div class="all_control_input_buttons_textar">
                <div class="left">
                  <div class="Type_title">
                    <span>竞品&设备&制程</span>
                  </div>
                  <div>
                    <div class="title_input_button" v-show="pan_input!=1">
                      <div class="titles">
                        <span>设备型号</span>
                      </div>
                      <div class="all_input">

                        <el-select v-model="deviceChoice" filterable placeholder="请选择" style="width: 200px" clearable
                                   @change="change('d', companyChoice)">
                          <el-option
                              v-for="item in deviceTable"
                              :key="item.value"
                              :label="item.device_type"
                              :value="item.device_type">
                          </el-option>
                        </el-select>
                      </div>
                      <div>
                        <el-button @click="Pan_add_device_type">新增</el-button>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="title_input_button">
                      <div class="titles">
                        <span>制程工艺</span>
                      </div>
                      <div class="all_input">

                        <el-select v-model="processChoice" filterable placeholder="请选择" style="width: 200px">
                          <el-option
                              v-for="item in processTable"
                              :key="item.value"
                              :label="item.process_technology"
                              :value="item.process_technology">
                          </el-option>
                        </el-select>
                      </div>
                      <div>
                        <el-button @click="Pan_add_process">新增</el-button>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="title_input_button" v-show="pan_input!=5">
                      <div class="titles">
                        <span>竞品类别</span>
                      </div>
                      <div class="all_input">

                        <el-select v-model="categoryChoice" filterable placeholder="请选择" style="width: 200px">
                          <el-option
                              v-for="item in categoryTable"
                              :key="item.value"
                              :label="item.title"
                              :value="item.title">
                          </el-option>
                        </el-select>
                      </div>
                      <div>
                        <el-button @click="Pan_add_category">新增</el-button>

                      </div>
                    </div>
                  </div>
                </div>
                <div class="lefts">
                  <div class="title_input_buttons">
                    <div class="titles">
                      <span v-if="pan_input==1">竞品情况</span>
                      <span v-if="pan_input==3">设备情况</span>
                      <span v-if="pan_input==5">竞品情况</span>
                    </div>
                    <div class="all_input">
                      <el-input
                          style=""
                          type="textarea"
                          :rows="2"
                          placeholder="请输入内容"
                          v-model="equipment_condition" style="width:90%">
                      </el-input>
                    </div>

                  </div>
                  <div class="title_input_buttons">
                    <div class="titles">
                      <span>人员关系&活动</span>
                    </div>
                    <div class="all_input">
                      <el-input
                          type="textarea"
                          :rows="2"
                          placeholder="请输入内容"
                          v-model="personnel_relations" style="width:90%">
                      </el-input>
                    </div>
                  </div>
                  <div class="Login_button">
                    <el-upload
                        class="upload-demo"
                        action="http://hairong.zhongqinchina.com/api/up_files/upload"
                        :on-preview="handlePreview"
                        :on-remove="handleRemove"
                        :before-remove="beforeRemove"
                        :before-upload="beforeAvatarUpload"
                        :on-success="urlChange"
                        multiple
                        :limit="1"
                        :on-exceed="handleExceed"
                        :file-list="fileList">
                      <el-button type="primary" style="width:240px;margin-bottom:10px">点击上传</el-button>
                    </el-upload>
                  </div>
                </div>
              </div>
              <div class="button_update">
                <el-button type="primary" style="height: 56px; width: 240px;margin-bottom:10px" @click="updateAll"
                >点击提交
                </el-button
                >
              </div>
            </div>
          </div>
        </div>
        <div class="add_info" v-if="add_staff_type===1">
          <div class="add_staff_info_titleAndInput">
            <span>企业</span>
            <el-input style="width: 200px" :value="companyChoice.companyName" :disabled="false"
                      :v-model="staff_companyChoice=companyChoice.id"></el-input>
          </div>
          <div class="add_staff_info_titleAndInput">
            <span>姓名</span>
            <el-input style="width: 200px" v-model="staff_Name"></el-input>
          </div>
          <div class="add_staff_info_titleAndInput">
            <span>职务</span>
            <el-input style="width: 200px" v-model="staff_post"></el-input>
          </div>
          <div class="add_staff_info_titleAndInput">
            <span>手机号</span>
            <el-input style="width: 200px" v-model="staff_phone"></el-input>
          </div>
          <div class="add_staff_info_titleAndInput">
            <span>邮箱</span>
            <el-input style="width: 200px" v-model="staff_wechart"></el-input>
          </div>

          <div class="add_info_button">
            <el-button @click="addStaff">添加</el-button>
            <el-button @click="Pan_add_staff">返回</el-button>
          </div>
        </div>
        <div class="add_info" v-if="add_companyTable===1">
          <div class="add_staff_info_titleAndInput">
            <span>企业名称</span>
            <el-input style="width: 200px" v-model="add_company_name"></el-input>
          </div>
          <div class="add_staff_info_titleAndInput">
            <span>简称</span>
            <el-input style="width: 200px" v-model="add_company_abbreviation"></el-input>
          </div>
          <div class="add_info_button">
            <el-button @click="addcompany">添加</el-button>
            <el-button @click="Pan_add_companyTable">返回</el-button>
          </div>
        </div>
        <div class="add_info" v-if="add_staff_type===2">
          <div class="add_staff_info_titleAndInput">
            <span>企业</span>
            <el-input style="width: 200px" :value="FABcompanChoice.companyName" :disabled="false"
                      :v-model="staff_companyChoice=FABcompanChoice.id"></el-input>
          </div>
          <div class="add_staff_info_titleAndInput">
            <span>姓名</span>
            <el-input style="width: 200px" v-model="staff_Name"></el-input>
          </div>
          <div class="add_staff_info_titleAndInput">
            <span>手机号</span>
            <el-input style="width: 200px" v-model="staff_phone"></el-input>
          </div>
          <div class="add_staff_info_titleAndInput">
            <span>邮箱</span>
            <el-input style="width: 200px" v-model="staff_wechart"></el-input>
          </div>
          <div class="add_staff_info_titleAndInput">
            <span>职务</span>
            <el-input style="width: 200px" v-model="staff_post"></el-input>
          </div>
          <div class="add_info_button">
            <el-button @click="addFABStaff">添加</el-button>
            <el-button @click="Pan_add_staff">返回</el-button>
          </div>
        </div>
        <div class="add_info" v-if="add_companyTable===2">
          <div class="add_staff_info_titleAndInput">
            <span>企业名称</span>
            <el-input style="width: 200px" v-model="add_company_name"></el-input>
          </div>

          <div class="add_staff_info_titleAndInput">
            <span>类型</span>
            <el-input style="width: 200px" v-model="type_fab"></el-input>
          </div>
          <div class="add_staff_info_titleAndInput">
            <span>地区</span>
            <el-input style="width: 200px" v-model="region_fab"></el-input>
          </div>
          <div class="add_info_button">
            <el-button @click="addFABcompany">添加</el-button>
            <el-button @click="Pan_add_companyTable">返回</el-button>
          </div>
        </div>
        <div class="add_info" v-if="add_staff_type===3">
          <div class="add_staff_info_titleAndInput">
            <span>企业</span>
            <el-input style="width: 200px" :value="OEMcompanyChoice.companyName" :disabled="false"
                      :v-model="staff_companyChoice=OEMcompanyChoice.id"></el-input>
          </div>
          <div class="add_staff_info_titleAndInput">
            <span>姓名</span>
            <el-input style="width: 200px" v-model="staff_Name"></el-input>
          </div>
          <div class="add_staff_info_titleAndInput">
            <span>手机号</span>
            <el-input style="width: 200px" v-model="staff_phone"></el-input>
          </div>
          <div class="add_staff_info_titleAndInput">
            <span>邮箱</span>
            <el-input style="width: 200px" v-model="staff_wechart"></el-input>
          </div>
          <div class="add_staff_info_titleAndInput">
            <span>职务</span>
            <el-input style="width: 200px" v-model="staff_post"></el-input>
          </div>
          <div class="add_info_button">
            <el-button @click="addOEMStaff">添加</el-button>
            <el-button @click="Pan_add_staff">返回</el-button>
          </div>
        </div>
        <div class="add_info" v-if="add_companyTable===3">
          <div class="add_staff_info_titleAndInput">
            <span>企业名称</span>
            <el-input style="width: 200px" v-model="add_company_name"></el-input>
          </div>
          <div class="add_staff_info_titleAndInput">
            <span>简称</span>
            <el-input style="width: 200px" v-model="add_company_abbreviation"></el-input>
          </div>
          <div class="add_info_button">
            <el-button @click="addOEMcompany">添加</el-button>
            <el-button @click="Pan_add_companyTable">返回</el-button>
          </div>
        </div>
        <div class="add_info" v-if="add_device_type===1">
          <div class="add_staff_info_titleAndInput">
            <span>设备型号</span>
            <el-input style="width: 200px" v-model="add_device"></el-input>
          </div>
          <div class="add_info_button">
            <el-button @click="addDevice">添加</el-button>
            <el-button @click="Pan_add_device_type">返回</el-button>
          </div>
        </div>
        <div class="add_info" v-if="add_process===1">
          <div class="add_staff_info_titleAndInput">
            <span>制程工艺</span>
            <el-input style="width: 200px" v-model="add_process_input"></el-input>
          </div>
          <div class="add_info_button">
            <el-button @click="addProcess">添加</el-button>
            <el-button @click="Pan_add_process">返回</el-button>
          </div>
        </div>
        <div class="add_info" v-if="add_category===1">
          <div class="add_staff_info_titleAndInput">
            <span>竞品类别</span>
            <el-input style="width: 200px" v-model="add_category_input"></el-input>
          </div>
          <div class="add_info_button">
            <el-button @click="addCategory">添加</el-button>
            <el-button @click="Pan_add_companyTable">返回</el-button>
          </div>
        </div>
        <!--        <div class="add_info" v-if="add_staff_type===1">-->
        <!--          <div class="add_staff_info_titleAndInput">-->
        <!--            <span>企业</span>-->
        <!--            <el-input style="width: 200px" :value="companyChoice.companyName" :disabled="false"-->
        <!--                      :v-model="staff_companyChoice=companyChoice.id"></el-input>-->
        <!--          </div>-->
        <!--          <div class="add_staff_info_titleAndInput">-->
        <!--            <span>姓名</span>-->
        <!--            <el-input style="width: 200px" v-model="staff_Name"></el-input>-->
        <!--          </div>-->
        <!--          <div class="add_staff_info_titleAndInput">-->
        <!--            <span>手机号</span>-->
        <!--            <el-input style="width: 200px" v-model="staff_phone"></el-input>-->
        <!--          </div>-->
        <!--          <div class="add_staff_info_titleAndInput">-->
        <!--            <span>微信</span>-->
        <!--            <el-input style="width: 200px" v-model="staff_wechart"></el-input>-->
        <!--          </div>-->
        <!--          <div class="add_info_button">-->
        <!--            <el-button @click="addStaff">添加</el-button>-->
        <!--            <el-button @click="Pan_add_staff">返回</el-button>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div class="add_info" v-if="add_companyTable===1">-->
        <!--          <div class="add_staff_info_titleAndInput">-->
        <!--            <span>企业名称</span>-->
        <!--            <el-input style="width: 200px" v-model="add_company_name"></el-input>-->
        <!--          </div>-->
        <!--          <div class="add_staff_info_titleAndInput">-->
        <!--            <span>简称</span>-->
        <!--            <el-input style="width: 200px" v-model="add_company_abbreviation"></el-input>-->
        <!--          </div>-->
        <!--          <div class="add_info_button">-->
        <!--            <el-button @click="addcompany">添加</el-button>-->
        <!--            <el-button @click="Pan_add_companyTable">返回</el-button>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div class="add_info" v-if="add_staff_type===2">-->
        <!--          <div class="add_staff_info_titleAndInput">-->
        <!--            <span>企业</span>-->
        <!--            <el-input style="width: 200px" :value="FABcompanChoice.companyName" :disabled="false"-->
        <!--                      :v-model="staff_companyChoice=FABcompanChoice.id"></el-input>-->
        <!--          </div>-->
        <!--          <div class="add_staff_info_titleAndInput">-->
        <!--            <span>姓名</span>-->
        <!--            <el-input style="width: 200px" v-model="staff_Name"></el-input>-->
        <!--          </div>-->
        <!--          <div class="add_staff_info_titleAndInput">-->
        <!--            <span>手机号</span>-->
        <!--            <el-input style="width: 200px" v-model="staff_phone"></el-input>-->
        <!--          </div>-->
        <!--          <div class="add_staff_info_titleAndInput">-->
        <!--            <span>微信</span>-->
        <!--            <el-input style="width: 200px" v-model="staff_wechart"></el-input>-->
        <!--          </div>-->
        <!--          <div class="add_info_button">-->
        <!--            <el-button @click="addFABStaff">添加</el-button>-->
        <!--            <el-button @click="Pan_add_staff">返回</el-button>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div class="add_info" v-if="add_companyTable===2">-->
        <!--          <div class="add_staff_info_titleAndInput">-->
        <!--            <span>企业名称</span>-->
        <!--            <el-input style="width: 200px" v-model="add_company_name"></el-input>-->
        <!--          </div>-->
        <!--          <div class="add_staff_info_titleAndInput">-->
        <!--            <span>简称</span>-->
        <!--            <el-input style="width: 200px" v-model="add_company_abbreviation"></el-input>-->
        <!--          </div>-->
        <!--          <div class="add_info_button">-->
        <!--            <el-button @click="addFABcompany">添加</el-button>-->
        <!--            <el-button @click="Pan_add_companyTable">返回</el-button>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div class="add_info" v-if="add_staff_type===3">-->
        <!--          <div class="add_staff_info_titleAndInput">-->
        <!--            <span>企业</span>-->
        <!--            <el-input style="width: 200px" :value="OEMcompanyChoice.companyName" :disabled="false"-->
        <!--                      :v-model="staff_companyChoice=OEMcompanyChoice.id"></el-input>-->
        <!--          </div>-->
        <!--          <div class="add_staff_info_titleAndInput">-->
        <!--            <span>姓名</span>-->
        <!--            <el-input style="width: 200px" v-model="staff_Name"></el-input>-->
        <!--          </div>-->
        <!--          <div class="add_staff_info_titleAndInput">-->
        <!--            <span>手机号</span>-->
        <!--            <el-input style="width: 200px" v-model="staff_phone"></el-input>-->
        <!--          </div>-->
        <!--          <div class="add_staff_info_titleAndInput">-->
        <!--            <span>微信</span>-->
        <!--            <el-input style="width: 200px" v-model="staff_wechart"></el-input>-->
        <!--          </div>-->
        <!--          <div class="add_info_button">-->
        <!--            <el-button @click="addOEMStaff">添加</el-button>-->
        <!--            <el-button @click="Pan_add_staff">返回</el-button>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div class="add_info" v-if="add_companyTable===3">-->
        <!--          <div class="add_staff_info_titleAndInput">-->
        <!--            <span>企业名称</span>-->
        <!--            <el-input style="width: 200px" v-model="add_company_name"></el-input>-->
        <!--          </div>-->
        <!--          <div class="add_staff_info_titleAndInput">-->
        <!--            <span>简称</span>-->
        <!--            <el-input style="width: 200px" v-model="add_company_abbreviation"></el-input>-->
        <!--          </div>-->
        <!--          <div class="add_info_button">-->
        <!--            <el-button @click="addOEMcompany">添加</el-button>-->
        <!--            <el-button @click="Pan_add_companyTable">返回</el-button>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div class="add_info" v-if="add_device_type===1">-->
        <!--          <div class="add_staff_info_titleAndInput">-->
        <!--            <span>设备型号</span>-->
        <!--            <el-input style="width: 200px" v-model="add_device"></el-input>-->
        <!--          </div>-->
        <!--          <div class="add_info_button">-->
        <!--            <el-button @click="addDevice">添加</el-button>-->
        <!--            <el-button @click="Pan_add_device_type">返回</el-button>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div class="add_info" v-if="add_process===1">-->
        <!--          <div class="add_staff_info_titleAndInput">-->
        <!--            <span>制程工艺</span>-->
        <!--            <el-input style="width: 200px" v-model="add_process_input"></el-input>-->
        <!--          </div>-->
        <!--          <div class="add_info_button">-->
        <!--            <el-button @click="addProcess">添加</el-button>-->
        <!--            <el-button @click="Pan_add_process">返回</el-button>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div class="add_info" v-if="add_category===1">-->
        <!--          <div class="add_staff_info_titleAndInput">-->
        <!--            <span>竞品类别</span>-->
        <!--            <el-input style="width: 200px" v-model="add_category_input"></el-input>-->
        <!--          </div>-->
        <!--          <div class="add_info_button">-->
        <!--            <el-button @click="addCategory">添加</el-button>-->
        <!--            <el-button @click="Pan_add_companyTable">返回</el-button>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="test"
             v-show="add_staff_type!=0||add_companyTable!=0||add_device_type!=0||add_process!=0||add_category!=0"></div>
      </div>
    </div>
    <div></div>
  </div>
</template>

<script>
import {httpUrl} from "../components/publics";
import {createApp} from 'vue';

export default {
  name: "Main_menuPhone_JiaGeYuKuCun",
  data() {
    return {
      PanDuanShous: false,
      PanDuanShou: false,
      pan_title: "",
      pan_Show: false,
      pan_input: "",
      pan_input2: "",
      pan_input3: false,
      pan_input4: false,
      pan_input5: false, // 判断子切换
      pan_input6: false,//双数据切换判定
      jinxuan2: 1,
      jinxuan3: 3,
      jinxuan4: 5,
      selectFAB: 3,
      add_companyTable: 0,
      add_staff_type: 0,
      add_device_type: 0,
      add_process: 0,
      add_category: 0,
      add_company_name: "",
      add_company_abbreviation: "",
      companyStaffTable: "",
      companyStaffChoice: "",
      jinxuan: "",//判断是否禁选和传过来的UserID进行比较
      selectC: 1,//单选框值
      companyTable: {},//公司列表
      FABcompanyTable: {},//FAB公司列表
      companyChoice: {},//公司列表
      OEMcompanyTable: {},//OEM公司列表
      OEMcompanyChoice: {},//公司列表
      FABcompanChoice: {},//FAB公司选择
      selectTable: {},//单选框列表
      deviceTable: {},//设备列表
      deviceChoice: "",//设备选择
      processTable: {},//制程工艺列表
      processChoice: "",//制程工艺列表
      categoryTable: {},//制程工艺列表
      categoryChoice: "",//制程工艺列表
      staff_Name: "",
      staff_phone: "",
      staff_wechart: "",
      staff_companyChoice: "",
      staff_name_select: "",
      FABstaff_name_select: "",
      OEMstaff_name_select: "",
      FABcompanyStaffTable: {},//FAB员工列表
      OEMcompanyStaffTable: {},//OEM员工列表
      equipment_condition: "",
      personnel_relations: "",
      add_device: "",
      add_process_input: "",
      add_category_input: "",
      selectOEM: 5,
      selectOEMs: "",
      urlImage: '',
      fileList: [],
      tableTable: [],
      user_leave: {},
      tableData: [],
      tableData2: [],
      key: "",
      second: "",
      page: 0
    };
  },
  mounted() {

    this.getUser();
    this.Name();
    this.selectName();
    this.selectcompany();
    this.selectFABcompany();
    this.selectOEMcompany();
    this.selectdevice();
    this.selectprocess();
    this.selectCategory();
    this.getUser();
    window.addEventListener('scroll', this.lazyLoading); // 滚动到底部，再加载的处理事件

  },
  watch: {
    companyChoice(newName, oldName) {
      // console.log(newName.id,'这里看的是参数')
      this.selectcompanystaff(newName.id);
    },
    FABcompanChoice(newName, oldName) {
      // console.log(newName.id,'这里看的是参数')
      this.selectFABcompanystaff(newName.id);
    },
    OEMcompanyChoice(newName, oldName) {
      // console.log(newName.id,'这里看的是参数')
      this.selectOEMcompanystaff(newName.id);
    },

  },
  destroyed() {
    console.log('是卸载吗');
    this.page = 0;
    window.removeEventListener('scroll', this.lazyLoading);
    console.log('卸载成功')
  },
  methods: {
    title_switch1(val) {
      if (val === 1) {
        return val = '竞品状况 @ Fab用户';
      } else if (val === 3) {
        return val = '设备信息 @ Fab用户';
      } else if (val === 5) {
        return val = '竞品状况 @ OEM用户';
      }
      if (val === 2) {
        return val = '竞争者活动 @ Fab用户';
      } else if (val === 4) {
        return val = 'OEM销售人员动态 @ Fab用户';
      } else if (val === 6) {
        return val = '竞争者动态 @ OEM用户';
      }
    },

    lazyLoading() { // 滚动到底部，再加载的处理事件
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      let clientHeight = document.documentElement.clientHeight;
      let scrollHeight = document.documentElement.scrollHeight;
      if (scrollTop + clientHeight >= scrollHeight) { // 滚动到底部，逻辑代码
        //事件处理
        if (this.pan_input != "" && this.second == '') {
          console.log("我已经滚动到底部了触发这个事件了1")//此处可以添加数据请求
          this.page += 1;
          console.log(this.pan_input, 'this.pan_input2')
          this.serchChanPin(this.pan_input)
        } else if (this.key != null && this.second == '') {
          console.log("我已经滚动到底部了触发这个事件了12")//此处可以添加数据请求
          this.page += 1;
          console.log(this.pan_input, 'this.pan_input45')
          this.serchChanPin4(this.pan_input)
        } else if (this.second != '') {
          console.log('看看我走的是这里吗')
          this.page += 1;
          console.log(this.second, '这里看的是第二象限')
          this.serchChanPin2(this.second)
          let as = this.second - 1
          console.log(as, '这里看的是as')
          this.serchChanPin(as)

        }
        // } else {
        //   console.log("這個是查詢后的嬾加載")//此处可以添加数据请求
        //   this.page++;
        //   this.serchChanPin2(this.pan_input)
        //   console.log(this.pan_input,'this.pan_input2')
        // }

      }
    },
    pan_switch(val) {
      if (val == 0) {
        this.pan_input3 = false;
        this.pan_Show = true;
        this.pan_input = true;

      } else if (val == 1) {
        this.pan_input3 = true
        this.pan_Show = false
      }
    },
    pan_switch2(val) {
      if (val == 0) {
        this.pan_input5 = true;
        this.pan_input6 = 0;
        console.log(this.pan_input5)
      } else if (val == 1) {
        this.pan_input5 = false;
        this.pan_input6 = 1;
        console.log(this.pan_input5, '这个位置看判断5')
      }
    },
    clearInput() {
      this.second="";
      this.pan_input2 = "";
      this.staff_name_select = "";
      this.FABstaff_name_select = "";
      this.OEMstaff_name_select = "";
      this.OEMcompanyChoice = "";
      this.companyChoice = "";
      this.FABcompanChoice = "";
      this.deviceChoice = "";
      this.processChoice = "";
      this.categoryChoice = "";
      this.ompanyStaffChoice = "";
      this.staff_companyChoice = "";
    },
    TianJiaTest(val) {

      // this.infoAll(val)
      this.Go_info(val);
    },
    Name() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/quadrant`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.tableTable = response.data.data;
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    getUser() {
      this.user_leave = JSON.parse(sessionStorage.getItem("user"));
      console.log(this.user_leave);
    },
    JingPinDengJi(val) {
      this.pan_input3 = false
      this.clearInput();
      this.pan_input = ""
      this.pan_input2 = ""
      this.pan_Show = true;
      this.pan_input4 = true;
      this.pan_input = val
      this.page = 0;
      this.serchChanPin(val)
    },
    JingPinDengJi2(val) {
      console.log('这个已经出发了')
      console.log(val)
      if (this.FABstaff_name_select != '' || this.OEMstaff_name_select != '' || this.staff_name_select != '') {
        this.pan_input = ""
        this.pan_input2 = ""
        this.pan_Show = false;
        this.pan_input = val
        this.second = val
        this.pan_input2 = val - 1
        console.log(this.pan_input2)
        this.serchChanPin(this.pan_input2)
        this.serchChanPin2(val)
        this.pan_input3 = true
      }
    },
    // JingPinDengJi2(val) {
    //   if (this.FABstaff_name_select != '' || this.OEMstaff_name_select != '' || this.staff_name_select != '' || this.key != '') {
    //     this.pan_input = val
    //     this.pan_input2 = val - 1
    //     this.serchChanPin(this.pan_input2)
    //     this.serchChanPin2(val)
    //   }
    // },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {

    },
    urlChange(e) {
      console.log('url', e);
      if (e.code == 200) {
        this.urlImage = e.data.img
      }
    },
    beforeAvatarUpload(file) {
      console.log('file', file);
      // accept=".jpg,.jpeg,.png,.pdf,.JPG,.JPEG,.PDF,DOC"

      let fileName = file.name.substring(file.name.lastIndexOf('.') + 1);
      var arr = ['png', 'jpeg', 'jpg', 'pdf', 'doc', 'PNG', 'JPEG', 'JPG', 'PDF', 'DOC'];
      let status = arr.findIndex((value, key) => {
        return fileName == value
      });
      console.log('fileName', fileName, status);
      if (status == -1) {
        this.$message('上传文件只能是 png、jpeg、jpg、pdf、doc格式!');
        return false
      }
      // if(!extension && !extension2) {
      //   this.$message({
      //     message: '上传文件只能是 xls、xlsx格式!',
      //     type: 'warning'
      //   });
      // }
    },
    //新增公司
    addcompany() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/enterpriseAdd",
              this.$qs.stringify({
                enterprise: this.add_company_name,
                // association_type
                abbreviation: this.add_company_abbreviation,

              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_companyTable = 0;
              this.selectcompany();
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
      console.log(this.staff_Name)
      console.log(this.staff_phone)
      console.log(this.staff_wechart)
      console.log(this.staff_companyChoice)
    },
    //新增FAB公司
    addFABcompany() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/enterpriseEndAdd",
              this.$qs.stringify({
                enterprise: this.add_company_name,
                // association_type
                // abbreviation: this.add_company_abbreviation,
                type: this.type_fab,
                region: this.region_fab,
              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_companyTable = 0;
              this.selectFABcompany();
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
      console.log(this.staff_Name)
      console.log(this.staff_phone)
      console.log(this.staff_wechart)
      console.log(this.staff_companyChoice)
    },
    //新增公司
    addOEMcompany() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/equipmentSupplierAdd",
              this.$qs.stringify({
                enterprise: this.add_company_name,
                // association_type
                abbreviation: this.add_company_abbreviation,

              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_companyTable = 0;
              this.selectOEMcompany();
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
      console.log(this.staff_Name)
      console.log(this.staff_phone)
      console.log(this.staff_wechart)
      console.log(this.staff_companyChoice)
    },
    //新增竞争公司销售人员
    addStaff() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/relatedPersonnelAdd",
              this.$qs.stringify({
                enterprise_id: this.staff_companyChoice,
                // association_type
                name: this.staff_Name,
                phone: this.staff_phone,
                email: this.staff_wechart,
                post: this.staff_post,
              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.selectcompanystaff(this.companyChoice.id);
              this.add_staff_type = 0;

            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
      console.log(this.staff_Name)
      console.log(this.staff_phone)
      console.log(this.staff_wechart)
      console.log(this.staff_companyChoice)
    },
    //新增FAB销售人员
    addFABStaff() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/relatedPersonnelEndAdd",
              this.$qs.stringify({
                enterprise_end_id: this.staff_companyChoice,
                // association_type
                name: this.staff_Name,
                phone: this.staff_phone,
                email: this.staff_wechart,
                post: this.staff_post,
              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_staff_type = 0;
              this.selectFABcompanystaff(this.FABcompanChoice.id)
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
      console.log(this.staff_Name)
      console.log(this.staff_phone)
      console.log(this.staff_wechart)
      console.log(this.staff_companyChoice)
    },
    //新增设备型号
    addDevice() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/deviceTypeAdd",
              this.$qs.stringify({
                device_type: this.add_device,
                equipment_supplier_id: this.OEMcompanyChoice.id
              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_device_type = 0;
              this.selectdevice()
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
      console.log(this.staff_Name)
      console.log(this.staff_phone)
      console.log(this.staff_wechart)
      console.log(this.staff_companyChoice)
    },
    //新增制程工艺
    addProcess() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/processTechnologyAdd",
              this.$qs.stringify({
                process_technology: this.add_process_input
              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_process = 0;
              this.selectprocess()
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));

    },
    //新增竞品类别
    addCategory() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/categoryAdd",
              this.$qs.stringify({
                title: this.add_category_input
              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_category = 0;
              this.selectCategory()
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));

    },
    //新增OEM销售人员
    addOEMStaff() {
      this.axios
          .post(
              httpUrl + "/api/competitive_product/relatedPersonnelSupplierAdd",
              this.$qs.stringify({
                enterprise_supplier_id: this.staff_companyChoice,
                // association_type
                name: this.staff_Name,
                phone: this.staff_phone,
                email: this.staff_wechart,
                post: this.staff_post,
              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_staff_type = 0;
              this.selectOEMcompanystaff(this.OEMcompanyChoice.id)
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
      console.log(this.staff_Name)
      console.log(this.staff_phone)
      console.log(this.staff_wechart)
      console.log(this.staff_companyChoice)
    },
    // //新增公司
    // addcompany() {
    //   this.axios
    //       .post(
    //           httpUrl + "/api/competitive_product/enterpriseAdd",
    //           this.$qs.stringify({
    //             enterprise: this.add_company_name,
    //             // association_type
    //             abbreviation: this.add_company_abbreviation,
    //
    //           })
    //       )
    //       .then((response) => {
    //         if (response.data.code == 200) {
    //           this.$message(response.data.message);
    //           console.log("success", response.data);
    //           this.add_companyTable = 0;
    //           this.selectcompany();
    //         } else {
    //           console.log(response.data.code);
    //           this.$message(response.data.message);
    //         }
    //       })
    //       .catch((error) => console.log(error, "error"));
    //   console.log(this.staff_Name)
    //   console.log(this.staff_phone)
    //   console.log(this.staff_wechart)
    //   console.log(this.staff_companyChoice)
    // },
    // //新增FAB公司
    // addFABcompany() {
    //   this.axios
    //       .post(
    //           httpUrl + "/api/competitive_product/enterpriseEndAdd",
    //           this.$qs.stringify({
    //             enterprise: this.add_company_name,
    //             // association_type
    //             abbreviation: this.add_company_abbreviation,
    //
    //           })
    //       )
    //       .then((response) => {
    //         if (response.data.code == 200) {
    //           this.$message(response.data.message);
    //           console.log("success", response.data);
    //           this.add_companyTable = 0;
    //           this.selectFABcompany();
    //         } else {
    //           console.log(response.data.code);
    //           this.$message(response.data.message);
    //         }
    //       })
    //       .catch((error) => console.log(error, "error"));
    //   console.log(this.staff_Name)
    //   console.log(this.staff_phone)
    //   console.log(this.staff_wechart)
    //   console.log(this.staff_companyChoice)
    // },
    // //新增公司
    // addOEMcompany() {
    //   this.axios
    //       .post(
    //           httpUrl + "/api/competitive_product/equipmentSupplierAdd",
    //           this.$qs.stringify({
    //             enterprise: this.add_company_name,
    //             // association_type
    //             abbreviation: this.add_company_abbreviation,
    //
    //           })
    //       )
    //       .then((response) => {
    //         if (response.data.code == 200) {
    //           this.$message(response.data.message);
    //           console.log("success", response.data);
    //           this.add_companyTable = 0;
    //           this.selectOEMcompany();
    //         } else {
    //           console.log(response.data.code);
    //           this.$message(response.data.message);
    //         }
    //       })
    //       .catch((error) => console.log(error, "error"));
    //   console.log(this.staff_Name)
    //   console.log(this.staff_phone)
    //   console.log(this.staff_wechart)
    //   console.log(this.staff_companyChoice)
    // },
    // //新增竞争公司销售人员
    // addStaff() {
    //   this.axios
    //       .post(
    //           httpUrl + "/api/competitive_product/relatedPersonnelAdd",
    //           this.$qs.stringify({
    //             enterprise_id: this.staff_companyChoice,
    //             // association_type
    //             name: this.staff_Name,
    //             phone: this.staff_phone,
    //             wechat: this.staff_wechart,
    //           })
    //       )
    //       .then((response) => {
    //         if (response.data.code == 200) {
    //           this.$message(response.data.message);
    //           console.log("success", response.data);
    //           this.selectcompanystaff(this.companyChoice.id);
    //           this.add_staff_type = 0;
    //
    //         } else {
    //           console.log(response.data.code);
    //           this.$message(response.data.message);
    //         }
    //       })
    //       .catch((error) => console.log(error, "error"));
    //   console.log(this.staff_Name)
    //   console.log(this.staff_phone)
    //   console.log(this.staff_wechart)
    //   console.log(this.staff_companyChoice)
    // },
    // //新增FAB销售人员
    // addFABStaff() {
    //   this.axios
    //       .post(
    //           httpUrl + "/api/competitive_product/relatedPersonnelEndAdd",
    //           this.$qs.stringify({
    //             enterprise_end_id: this.staff_companyChoice,
    //             // association_type
    //             name: this.staff_Name,
    //             phone: this.staff_phone,
    //             wechat: this.staff_wechart,
    //           })
    //       )
    //       .then((response) => {
    //         if (response.data.code == 200) {
    //           this.$message(response.data.message);
    //           console.log("success", response.data);
    //           this.add_staff_type = 0;
    //           this.selectFABcompanystaff(this.FABcompanChoice.id)
    //         } else {
    //           console.log(response.data.code);
    //           this.$message(response.data.message);
    //         }
    //       })
    //       .catch((error) => console.log(error, "error"));
    //   console.log(this.staff_Name)
    //   console.log(this.staff_phone)
    //   console.log(this.staff_wechart)
    //   console.log(this.staff_companyChoice)
    // },
    // //新增设备型号
    // addDevice() {
    //   this.axios
    //       .post(
    //           httpUrl + "/api/competitive_product/deviceTypeAdd",
    //           this.$qs.stringify({
    //             device_type: this.add_device
    //           })
    //       )
    //       .then((response) => {
    //         if (response.data.code == 200) {
    //           this.$message(response.data.message);
    //           console.log("success", response.data);
    //           this.add_device_type = 0;
    //           this.selectdevice()
    //         } else {
    //           console.log(response.data.code);
    //           this.$message(response.data.message);
    //         }
    //       })
    //       .catch((error) => console.log(error, "error"));
    //   console.log(this.staff_Name)
    //   console.log(this.staff_phone)
    //   console.log(this.staff_wechart)
    //   console.log(this.staff_companyChoice)
    // },
    // //新增制程工艺
    // addProcess() {
    //   this.axios
    //       .post(
    //           httpUrl + "/api/competitive_product/processTechnologyAdd",
    //           this.$qs.stringify({
    //             process_technology: this.add_process_input
    //           })
    //       )
    //       .then((response) => {
    //         if (response.data.code == 200) {
    //           this.$message(response.data.message);
    //           console.log("success", response.data);
    //           this.add_process = 0;
    //           this.selectprocess()
    //         } else {
    //           console.log(response.data.code);
    //           this.$message(response.data.message);
    //         }
    //       })
    //       .catch((error) => console.log(error, "error"));
    //
    // },
    // //新增竞品类别
    // addCategory() {
    //   this.axios
    //       .post(
    //           httpUrl + "/api/competitive_product/categoryAdd",
    //           this.$qs.stringify({
    //             title: this.add_category_input
    //           })
    //       )
    //       .then((response) => {
    //         if (response.data.code == 200) {
    //           this.$message(response.data.message);
    //           console.log("success", response.data);
    //           this.add_category = 0;
    //           this.selectCategory()
    //         } else {
    //           console.log(response.data.code);
    //           this.$message(response.data.message);
    //         }
    //       })
    //       .catch((error) => console.log(error, "error"));
    //
    // },
    // //新增OEM销售人员
    // addOEMStaff() {
    //   this.axios
    //       .post(
    //           httpUrl + "/api/competitive_product/relatedPersonnelSupplierAdd",
    //           this.$qs.stringify({
    //             enterprise_supplier_id: this.staff_companyChoice,
    //             // association_type
    //             name: this.staff_Name,
    //             phone: this.staff_phone,
    //             wechat: this.staff_wechart,
    //           })
    //       )
    //       .then((response) => {
    //         if (response.data.code == 200) {
    //           this.$message(response.data.message);
    //           console.log("success", response.data);
    //           this.add_staff_type = 0;
    //           this.selectOEMcompanystaff(this.OEMcompanyChoice.id)
    //         } else {
    //           console.log(response.data.code);
    //           this.$message(response.data.message);
    //         }
    //       })
    //       .catch((error) => console.log(error, "error"));
    //   console.log(this.staff_Name)
    //   console.log(this.staff_phone)
    //   console.log(this.staff_wechart)
    //   console.log(this.staff_companyChoice)
    // },
    changeSelect() {
      this.$forceUpdate()
    },
    //判断是否打开新增竞争公司销售人员弹窗
    Pan_add_staff() {
      if (this.add_staff_type == 0) {
        if (Object.keys(this.companyChoice).length != "") {
          this.add_staff_type = 1
        } else {
          this.$message("请填写竞争公司后在进行添加")
        }

      } else {
        this.add_staff_type = 0
      }
    },
    //判断是否打开新增FAB销售人员弹窗
    Pan_add_FABstaff() {
      if (this.add_staff_type == 0) {
        if (Object.keys(this.FABcompanChoice).length != "") {
          this.add_staff_type = 2
        } else {
          this.$message("请填写竞争公司后在进行添加")
        }

      } else {
        this.add_staff_type = 0
      }
    },
    //判断是否新增竞争公司
    Pan_add_companyTable() {
      if (this.add_companyTable == 0) {
        this.add_companyTable = 1
      } else {
        this.add_companyTable = 0
      }
    },
    Pan_add_device_type() {
      if (this.add_device_type == 0) {
        this.add_device_type = 1
      } else {
        this.add_device_type = 0
      }
    },
    Pan_add_category() {
      if (this.add_category == 0) {
        this.add_category = 1
      } else {
        this.add_category = 0
      }
    },
    Pan_add_process() {
      if (this.add_process == 0) {
        this.add_process = 1
      } else {
        this.add_process = 0
      }
    },
    //判断是否打开新增OEM销售人员弹窗
    Pan_add_OEMstaff() {
      if (this.add_staff_type == 0) {
        if (Object.keys(this.OEMcompanyChoice).length != "") {
          this.add_staff_type = 3
        } else {
          this.$message("请填写竞争公司后在进行添加")
        }

      } else {
        this.add_staff_type = 0
      }
    },
    //判断是否新增竞争公司
    change(params, val) {
      console.log(params, '这里测试的是parames');
      if (params == "a" && val != "") {
        this.staff_name_select = "";
      }
      if (params == "b" && val != "") {
        this.FABstaff_name_select = "";
      }
      if (params == "c" && val != "") {
        this.OEMstaff_name_select = "";
      }
    },
    //单选框赋值
    selectName() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/association `
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.selectTable = response.data.data;
              // console.log(selectTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询公司列表
    selectcompany() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/enterprise `
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.companyTable = response.data.data;
              console.log(companyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询FAB列表
    selectFABcompany() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/enterprise_end`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.FABcompanyTable = response.data.data;
              // console.log(FABcompanyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询OEM列表
    selectOEMcompany() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/equipment_supplier`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.OEMcompanyTable = response.data.data;
              // console.log(FABcompanyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询设备列表
    selectdevice() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/device_type`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.deviceTable = response.data.data;
              // console.log(FABcompanyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询制程工艺列表
    selectprocess() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/process_technology`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.processTable = response.data.data;
              // console.log(FABcompanyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //竞品类别列表
    selectCategory() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/category`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.categoryTable = response.data.data;
              // console.log(FABcompanyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询竞争对手销售人员
    selectcompanystaff(newNames) {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/related_personnel?enterprise_id=${newNames} `
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.companyStaffTable = response.data.data;
              console.log(companyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    selectFABcompanystaff(newNames) {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/related_personnel_end?enterprise_end_id=${newNames} `
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.FABcompanyStaffTable = response.data.data;
              console.log(companyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    selectOEMcompanystaff(newNames) {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/related_personnel_supplier?enterprise_supplier_id=${newNames} `
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.OEMcompanyStaffTable = response.data.data;
              console.log(companyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询制程工艺
    updateAll() {
      if (this.quadrant_id == 1) {
        this.selectC = 1;
        this.selectFAB = 3;
        this.selectOEMs = '';
      } else if (this.quadrant_id == 3) {
        this.selectC = '';
        this.selectFAB = 3;
        this.selectOEMs = 5
      } else if (this.quadrant_id == 5) {
        this.selectC = 1;
        this.selectOEMs = 5;
        this.selectFAB = '';
      }
      this.axios
          .post(
              httpUrl + "/api/competitive_product/competitiveProductAdd",
              this.$qs.stringify({
                user_id: this.user_leave.id,
                quadrant_id: this.pan_input,
                enterprise_id: this.companyChoice.id,
                enterprise_user_id: this.staff_name_select,

                enterprise_type: 1,
                enterprise_end_type: 3,
                equipment_supplier_type: 5,

                enterprise_end_id: this.FABcompanChoice.id,
                enterprise_end_user_id: this.FABstaff_name_select,

                equipment_supplier_id: this.OEMcompanyChoice.id,
                equipment_supplier_user_id: this.OEMstaff_name_select,

                device_type: this.deviceChoice,
                process_technology: this.processChoice,
                category: this.categoryChoice,
                equipment_condition: this.equipment_condition,
                personnel_relations: this.personnel_relations,
              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_staff_type = 0;
              this.selectFABcompany()
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
      console.log(this.staff_Name)
      console.log(this.staff_phone)
      console.log(this.staff_wechart)
      console.log(this.staff_companyChoice)
    },
    //初次进入系统时所使用的。
    serchChanPin(valas) {
      let suser_id = JSON.parse(sessionStorage.getItem("user"));
      let selectID = suser_id.id;
      console.log(selectID);
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/competitiveProductList?key=${this.key}&user_id=${this.user_leave.id}&quadrant_id=${valas}&page=${this.page}`
          )
          .then((response) => {
            if (response.data.code == 200) {
              let testDate = response.data.data.data;
              this.totle = response.data.data.total;
              let a = testDate.map(value => {
                // let b = ;
                this.tableData.push(value)
                // console.log(this.tableData)
              })

              console.log(this.totle)
              console.log(this.tableData)
              if (response.data.code == 401) {
                this.$message(response.data.message);
              } else {
                // response.data.data.map((value, key) => {
                //   if (value.child.length > 0) {
                //     value.child.map((val, num) => {
                //       val["id"] = value.id * 10 + num;
                //     });
                //   }
                // });
                // this.tableData = response.data.data.data;
              }
              // this.tableData = response.data.data
              // console.log(this.tableData.data)
              //     newItemNo:"",//新料号
              //     oldMaterialNo:"",//旧料号
              //     internal_meridian:"", // 产品内径
              //     wire_diameter:"",//产品线径
              //     ChanPinXiaoLei_choice:"",//产品小类选择
              //     CaiZhi_choice:"",//材质选择   //material
              //     BiaoZhun_Choice:"",//标准选择
              //     YingDu_Choice:"",//硬度选择
              //     standard_code:"",//标准代码
              //     inquiry_no:"",//询价单号
              //     CaiLiaoXinXi_Code_Choice:"",//材料信息选择
              //     ChanPinDaLei_choice:"", // 产品大类选择
              //     YanSe_Choice:"",//颜色选择
              //     ChanPinDaLei_Select:[],  // 产品大类下拉框
              //     ChanPinXiaoLei_Select:[],//产品小类下拉框
              //     CaiZhi_select:[], //材质选择拉下
              //     BiaoZhun_Select:[],//标准下拉框
              //     YingDu_Select:[],//硬度下拉框
              //     CaiLiaoXinXi_Code_Select:[],//材料信息下拉框
              //     YanSe_Select:[],//颜色下拉框
            }
            // this.$message("搜索成功");

          })
          .catch((error) => console.log(error, "error"));
    },
    //输入框使用搜索
    serchChanPin4(valas) {
      let suser_id = JSON.parse(sessionStorage.getItem("user"));
      let selectID = suser_id.id;
      console.log(selectID);
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/competitiveProductList?key=${this.key}&user_id=${this.user_leave.id}&quadrant_id=${valas}&page=${this.page}`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.tableData = response.data.data.data;
              this.totle = response.data.data.total;
              this.pan_input3 = !this.pan_input3
              this.pan_Show = !this.pan_Show
              console.log(this.totle)
              console.log(this.tableData)
              if (response.data.code == 401) {
                this.$message(response.data.message);
              } else {
                // response.data.data.map((value, key) => {
                //   if (value.child.length > 0) {
                //     value.child.map((val, num) => {
                //       val["id"] = value.id * 10 + num;
                //     });
                //   }
                // });
                this.tableData = response.data.data.data;
              }
              // this.tableData = response.data.data
              // console.log(this.tableData.data)
              //     newItemNo:"",//新料号
              //     oldMaterialNo:"",//旧料号
              //     internal_meridian:"", // 产品内径
              //     wire_diameter:"",//产品线径
              //     ChanPinXiaoLei_choice:"",//产品小类选择
              //     CaiZhi_choice:"",//材质选择   //material
              //     BiaoZhun_Choice:"",//标准选择
              //     YingDu_Choice:"",//硬度选择
              //     standard_code:"",//标准代码
              //     inquiry_no:"",//询价单号
              //     CaiLiaoXinXi_Code_Choice:"",//材料信息选择
              //     ChanPinDaLei_choice:"", // 产品大类选择
              //     YanSe_Choice:"",//颜色选择
              //     ChanPinDaLei_Select:[],  // 产品大类下拉框
              //     ChanPinXiaoLei_Select:[],//产品小类下拉框
              //     CaiZhi_select:[], //材质选择拉下
              //     BiaoZhun_Select:[],//标准下拉框
              //     YingDu_Select:[],//硬度下拉框
              //     CaiLiaoXinXi_Code_Select:[],//材料信息下拉框
              //     YanSe_Select:[],//颜色下拉框
            }
            // this.$message("搜索成功");

          })
          .catch((error) => console.log(error, "error"));
    },
    serchChanPin2(valas) {
      let suser_id = JSON.parse(sessionStorage.getItem("user"));
      let selectID = suser_id.id;
      this.totle2 = '';

      console.log(selectID);
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/competitiveProductList?key=${this.key}&user_id=${this.user_leave.id}&quadrant_id=${valas}&page=${this.page}`
          )
          .then((response) => {
            if (response.data.code == 200) {
              let testDate2 = response.data.data.data;
              this.totle2 = response.data.data.total
              console.log(this.tableData2)
              let a = testDate2.map(value => {
                // let b = ;
                this.tableData2.push(value)
                // console.log(this.tableData)
              })
              // this.tableData = response.data.data
              // console.log(this.tableData.data)
              //     newItemNo:"",//新料号
              //     oldMaterialNo:"",//旧料号
              //     internal_meridian:"", // 产品内径
              //     wire_diameter:"",//产品线径
              //     ChanPinXiaoLei_choice:"",//产品小类选择
              //     CaiZhi_choice:"",//材质选择   //material
              //     BiaoZhun_Choice:"",//标准选择
              //     YingDu_Choice:"",//硬度选择
              //     standard_code:"",//标准代码
              //     inquiry_no:"",//询价单号
              //     CaiLiaoXinXi_Code_Choice:"",//材料信息选择
              //     ChanPinDaLei_choice:"", // 产品大类选择
              //     YanSe_Choice:"",//颜色选择
              //     ChanPinDaLei_Select:[],  // 产品大类下拉框
              //     ChanPinXiaoLei_Select:[],//产品小类下拉框
              //     CaiZhi_select:[], //材质选择拉下
              //     BiaoZhun_Select:[],//标准下拉框
              //     YingDu_Select:[],//硬度下拉框
              //     CaiLiaoXinXi_Code_Select:[],//材料信息下拉框
              //     YanSe_Select:[],//颜色下拉框
            }
            // this.$message("搜索成功");
            // this.$message(response.data.message);
          })
          .catch((error) => console.log(error, "error"));
    },
    infoAll(infoID) {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/competitiveProductDetails?id=${infoID}`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.tableDataInfo = response.data.data;
              console.log(this.tableDataInfo)

              if (response.data.code == 401) {
                this.$message(response.data.message);
              } else {
                // response.data.data.map((value, key) => {
                //   if (value.child.length > 0) {
                //     value.child.map((val, num) => {
                //       val["id"] = value.id * 10 + num;
                //     });
                //   }
                // });
                this.tableDataInfo = response.data.data;
              }
              // this.tableData = response.data.data
              // console.log(this.tableData.data)
              //     newItemNo:"",//新料号
              //     oldMaterialNo:"",//旧料号
              //     internal_meridian:"", // 产品内径
              //     wire_diameter:"",//产品线径
              //     ChanPinXiaoLei_choice:"",//产品小类选择
              //     CaiZhi_choice:"",//材质选择   //material
              //     BiaoZhun_Choice:"",//标准选择
              //     YingDu_Choice:"",//硬度选择
              //     standard_code:"",//标准代码
              //     inquiry_no:"",//询价单号
              //     CaiLiaoXinXi_Code_Choice:"",//材料信息选择
              //     ChanPinDaLei_choice:"", // 产品大类选择
              //     YanSe_Choice:"",//颜色选择
              //     ChanPinDaLei_Select:[],  // 产品大类下拉框
              //     ChanPinXiaoLei_Select:[],//产品小类下拉框
              //     CaiZhi_select:[], //材质选择拉下
              //     BiaoZhun_Select:[],//标准下拉框
              //     YingDu_Select:[],//硬度下拉框
              //     CaiLiaoXinXi_Code_Select:[],//材料信息下拉框
              //     YanSe_Select:[],//颜色下拉框
            }
            // this.$message("搜索成功");

          })
          .catch((error) => console.log(error, "error"));
    },
    reflash(val) {
      this.page = val;
      console.log(this.page, '这里看的是page');
      console.log(this.pan_input, '这里看的是pan_input')
      this.serchChanPin(this.pan_input)
    },
    reflash2(val) {
      this.page = val;
      console.log(this.page, '这里看的是page');
      console.log(this.pan_input2, '这里看的是pan_input2')
      this.serchChanPin2(this.pan_input)
    },
    Go_info(val) {

      this.clearInput();
      this.$router.push(
          {
            name: "CompetitionRegistrationInfo_phone",
            params: {
              data: val
            }
          }
      );

    }
  },
};
</script>

<style>
</style>
<style scoped>
.CompetitiveChoice {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 40%;
  height: 70%;
}

.CompetitiveChoice_button_alone {

  height: 80%;
  width: 90%;
  justify-content: space-around;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 4px;
}

.CompetitiveChoice_button {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 270pt;
  height: 102pt;

  border-radius: 4px;
}

.all_part {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-image: url("../assets/table_logo2.png");
}

.main_button {
  flex-direction: column;
  align-items: center;
  justify-content: center;
  display: flex;
  width: 100%;
  height: 85%;
}

.logo {
  background-image: url("../assets/main_menu_Phone/bg@3x.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
  height: 142pt;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo img {
  margin-top: 18px;
}

.JiaGeKuCun {
  width: 100%;
  margin-top: 20px;
  align-items: center;
  justify-content: space-around;
  display: flex;
  flex-direction: row;
}

.button {
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 120pt;
  width: 120pt;
  background-color: #18a575;
  border-radius: 6px;
}

.buttons {
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 130pt;
  width: 130pt;
  background-color: none;
  border-radius: 6px;
}

.button img {
  width: 40pt;
  height: 44.5pt;
  display: flex;
}

.button span {
  font-weight: 500;
  color: #ffffff;
  font-size: 14pt;
  margin-top: 12px;
}

.TwoButton {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.search_button {
  margin-bottom: 20px;
}

.alone_span_title {
  color: #ffffff;
  font-size: 14px;
}

.alone_span_user {
  color: #ffffff;
  font-size: 20px;
}

.Competitive_span {
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.CompetitiveChoice {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
  height: 100%;

}

.CompetitiveChoice_button_alone {
  background: #8EC31F;
  height: 80%;
  width: 90%;
  justify-content: space-around;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 4px;

}

.CompetitiveChoice_button {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 120pt;
  height: 60pt;
  border-radius: 4px;
}

.CompetitiveChoice_buttonss {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120pt;
  height: 60pt;
  border-radius: 4px;
}

.CompetitiveChoice_buttonss div {
  /*background: #FC6700*/
  background: #999999;
}

.CompetitiveChoice_buttonss1 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120pt;
  height: 60pt;
  border-radius: 4px;
}

.CompetitiveChoice_buttonss1 div {
  background: #99c0db;
}

.CompetitiveChoice_buttonss2 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120pt;
  height: 60pt;
  border-radius: 4px;
}

.CompetitiveChoice_buttonss2 div {
  background: #99c0db;
}

.CompetitiveChoice_buttonss3 {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 120pt;
  height: 60pt;
  border-radius: 4px;
}

.CompetitiveChoice_buttonss3 div {
  background: #99c0db;
}

.Main_menu_button_cl {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.Main_menu_button_cls {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.el-radio-group >>> .el-radio is-checked >>> .el-radio {
  margin-right: 15px;
}

.add_staff_info_titleAndInput {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  text-align: right;

}

.add_staff_info_titleAndInput span {
  width: 22%;
  text-align: right;
}

.add_info {
  width: 85%;
  height: 48%;
  background: #42b983;
  background: rgb(255, 255, 255);
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  border-radius: 6px;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 9999;
}

.heads_menus {
  padding: 0;
  margin: 0;
  width: 74%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: rgb(235, 235, 235) 1px solid;
  align-items: center;
}

.heads_menu {
  padding: 0;
  margin: 0;
  width: 74%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: rgb(235, 235, 235) 1px solid;
  align-items: center;
}

.heads_menu_icon img {
  width: 24px;
}

.heads {
  padding-top: 40px;
  flex-direction: column;
  width: 42%;
  justify-content: space-around;
  display: flex;
  align-items: center;
  height: 300px;
  background-color: #ffffff;
  position: fixed;
  right: 0;
  z-index: 98;
  border-radius: 4px;
  box-shadow: 2px 1px 6px 6px #ccc;
}

.heads span {
  color: #000;
  font-size: 13px;
  line-height: 20px;
  font-weight: 250;
}

.heads_button {
  width: 70%;
  height: 40px;
  display: flex;

  align-items: center;
  justify-content: center;
}

.heads_menu {
  padding: 0;
  margin: 0;
  width: 74%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: rgb(235, 235, 235) 1px solid;
  align-items: center;
}

.heads_menu_icon img {
  width: 24px;
}

.input_left {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.list_div_div {
  width: 30%;
  display: flex;
  flex-direction: column;
  margin-right: 10px;
}

.all_part {
  min-height: 100vh;
  background-color: #f2f2f2;
}

.head {
  width: 100%;
  /* justify-content: space-between; */
  display: flex;
  align-items: center;
  height: 45px;
  background-image: url("../assets/main_menu_Phone/bg@3x.png");
  position: fixed;
  z-index: 99;
}

.head span {
  color: #ffffff;
  font-size: 20px;
  line-height: 20px;
  font-weight: 550;
}

.back img {
  margin-top: 5px;
}

.titleName {
  display: flex;
  justify-content: center;
}

.back {
  margin: 0 5px;
}

.all_input {
  display: flex;
  flex-direction: row;
  padding: 0 5px;
  justify-content: center;
  height: 32%;
  align-items: center;

}

.all_input_top {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.Ctrl_padding {
  height: 40%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.all_input_top_top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.all_input_all {
  height: 80%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 10px;
}

.all_button {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 15px;
  margin-top: 15px;
}

.input {
  margin-bottom: 10px;
}

.all_key {
  display: flex;
  flex-direction: row;
}

.two_spans {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: aqua;
}

.Key {
  width: 48%;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 8pt;
  margin-bottom: 4px;
  justify-content: space-between;
}

.serch {
  width: 60%;
}

.list_div {
  margin-top: 20px;
  background: #ffffff;
  background-image: url("../assets/table_logo2.png");
  border-radius: 5px;
  padding: 10px 7px;
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
}

.submit_button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 10px;
  margin-top: 10px;

}

.all_second_button {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-around;
}

.titleAndicon {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.title_icon {
  margin-right: 20px;
}

.sousuoButton {
  position: relative;
}

.sousuo_icon {
  top: 16px;
  left: 12px;
  position: absolute;
}

.ChongZhi {
  position: relative;
}

.icon_chong {
  top: 16px;
  left: 10px;
  position: absolute;
}

.ShouQi {
  margin-bottom: 10px;
}

.icon_Shou {
  top: 14px;
  left: 12px;
  position: absolute;
}

.icon_Shous {
  top: 15px;
  left: 12px;
  position: absolute;
  transform: rotate(180deg);
}

.all_spans1 {
  width: 50%;
  display: flex;
  flex-direction: column;
}

.all_spans {
  padding: 0 10px;
}

.titles {

  margin-top: 10px;
  display: flex;
  margin-bottom: 10px;

}

.ss {
  height: 55px;
}

.XinJiuBianHao {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.second_span {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
}

.double_span {
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  width: 100%;
}

.double_spans {
  width: 48%;
}

.list_div_divs {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.list_div_div {
  width: 30%;
  display: flex;
  flex-direction: column;
  margin-right: 10px;
}

.list_div {
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  padding: 6px 14px;
  /* background-image: url(./../assets/img_cx_sylogo@2x.png); */
  background-size: 190px 102px;
}

.list_div_p_span {
  color: #008de3;
}

.list_div_span {
  color: #222222;
}

.list_div_p {
  font-size: 12px;
  line-height: 12px;
  color: #a2a2a2;
  text-align: left;
  margin: 6.5px 0;
}

.all_input_bottom {
  flex-direction: column;
  height: 20%;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-around;
}

.input_left div {
  margin-bottom: 20px;
}

.all_control {
  margin-bottom: 20px;
  padding: 0 5px;
}

.all_control_input_button {
  display: flex;
  flex-direction: column;
}

.type_selection {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.Type_title {
  font-weight: 600;
  text-align: left;
  margin-bottom: 20px;
}

.title_input_button {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-around;
  margin-bottom: 20px;
}

.title_input_buttons {
  margin-bottom: 20px;
}

.popContainer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.3);
}


.heads_menus {
  padding: 0;
  margin: 0;
  width: 74%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: rgb(235, 235, 235) 1px solid;
  align-items: center;
}

.heads_menu {
  padding: 0;
  margin: 0;
  width: 74%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: rgb(235, 235, 235) 1px solid;
  align-items: center;
}

.heads_menu_icon img {
  width: 24px;
}


.head {
  width: 100%;
  justify-content: space-between;
  display: flex;
  align-items: center;
  height: 45px;
  background-image: url("../assets/main_menu_Phone/bg@3x.png");
  position: fixed;
  z-index: 99;
}

.heads {
  padding-top: 40px;
  flex-direction: column;
  width: 42%;
  justify-content: space-around;
  display: flex;
  align-items: center;
  height: 300px;
  background-color: #ffffff;
  position: fixed;
  right: 0;
  z-index: 98;
  border-radius: 4px;
  box-shadow: 2px 1px 6px 6px #ccc;
}

.heads span {
  color: #000;
  font-size: 13px;
  line-height: 20px;
  font-weight: 250;
}

.heads_button {
  width: 70%;
  height: 40px;
  display: flex;

  align-items: center;
  justify-content: center;
}

.head span {
  color: #ffffff;
  font-size: 20px;
  line-height: 20px;
  font-weight: 550;
}

.back img {
  margin-top: 5px;
}

.titleName {
  display: flex;
  justify-content: center;
}

.back {
  margin: 0 5px;
}


.all_input_top {
  /*height: 50%;*/
  width: 70%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: 10px 0;
}

.all_input_bottom {
  height: 50%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.all_input_top_top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.all_input_top_bottom {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.all_input_bottom_top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.all_input_bottom_bottom {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.all_button {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 15px;
  margin-top: 15px;
}

.input {
  margin-bottom: 10px;
}

.all_key {

  display: flex;
  flex-direction: column;
}

.two_spans {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: aqua;
}

.Key {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 8pt;
  margin-bottom: 4px;
  justify-content: space-between;
}

.serch {
  width: 60%;
}

.list_div {
  box-sizing: border-box;
  margin-top: 20px;
  background: #ffffff;
  background-image: url("../assets/table_logo2.png");
  border-radius: 5px;
  padding: 10px 7px;
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
}


.all_second_button {
  display: flex;
  flex-direction: row;
  margin-left: 10px;
}

.titleAndicon {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.title_icon {
  margin-right: 20px;
}

.sousuoButton {
  position: relative;
}

.sousuo_icon {
  top: 16px;
  left: 16px;
  position: absolute;
}

.ChongZhi {
  position: relative;
}

.icon_chong {
  top: 16px;
  left: 10px;
  position: absolute;
}

.ShouQi {
  margin-bottom: 10px;
}

.ShouQis {
  height: 74px;
  align-items: center;
  display: flex;
  flex-direction: column;

  transform: rotate(180deg);
}

.icon_Shou {
  top: 14px;
  left: 12px;
  position: absolute;
}

.icon_Shous {
  top: 15px;
  left: 12px;
  position: absolute;
  transform: rotate(180deg);
}

.all_spans1 {
  width: 50%;
  display: flex;
  flex-direction: column;
}

.all_spans {
  padding: 0 10px;
}

.titles {
  width: 100%;
  margin-top: 10px;
  display: flex;
}

.ss {
  height: 45px;
}

.XinJiuBianHao {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.second_span {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
}

.double_span {
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  width: 100%;
}

.double_spans {
  width: 48%;
}

.list_div_divs {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.list_div_div {
  width: 100%;
  display: flex;
  flex-direction: column;

}

.list_div {
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  padding: 6px 14px;
  /* background-image: url(./../assets/img_cx_sylogo@2x.png); */
  background-size: 190px 102px;
}

.list_div_p_span {
  color: #008de3;
}

.list_div_span {
  color: #222222;
  width: 300px
}

.list_div_p {
  font-size: 12px;
  line-height: 12px;
  color: #a2a2a2;
  text-align: left;
  margin: 6.5px 0;
}

.list_div_button {
  font-size: 12px;
  line-height: 12px;
  color: #a2a2a2;
  text-align: right;
  margin: 6.5px 0;
}

.CompetitiveChoices {
  display: flex;
  flex-direction: row;
}

.change_tab {
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-around;
  margin-bottom: 30px;
}

.bottom_ch {
  border-bottom: #008de3 2px solid;
}

.info_span_chack {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100%;
}


.type_selection_title {
  width: 100%;
  text-align: left;
  margin-bottom: 20px;
}

.title_switch_table {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-around;
  padding: 0 20px;
  box-sizing: border-box;
  margin-bottom: 20px;
  font-size: 14px;
}

.test {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
}

.CompetitiveChoice_button_ch {
  background: #bedfff;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120pt;
  height: 60pt;
  border-radius: 4px;

}
</style>
